import React from 'react'

const ProductReviews = ({
  reviews,
  totalReviews,
  avgStar,
  starsCount,
  selectedStar,
  loadingReviews,
  handleFilterStar,
  page = 1,
  totalPages = 1,
  handlePageChange
}) => {
  const formatCount = (count) => {
    if (!count) return '0'
    if (count >= 1000) {
      const val = (count / 1000).toFixed(1).replace(/\.0$/, '')
      return val.replace('.', ',') + 'RB'
    }
    return String(count)
  }

  const getPageNumbers = (currentPage, maxPages) => {
    if (maxPages <= 7) {
      return Array.from({ length: maxPages }, (_, i) => i + 1)
    }
    if (currentPage <= 4) {
      return [1, 2, 3, 4, 5, '...', maxPages]
    }
    if (currentPage >= maxPages - 3) {
      return [1, '...', maxPages - 4, maxPages - 3, maxPages - 2, maxPages - 1, maxPages]
    }
    return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', maxPages]
  }

  const visibleReviews = reviews ? reviews.filter(r => r.isShow !== false) : []

  return (
    <div className="cover-deskripsi" style={{ marginTop: '10px' }}>
      <h2>Ulasan Produk ({totalReviews})</h2>

      {/* Rating Summary & Star Filters */}
      <div
        style={{
          backgroundColor: '#fffdf5',
          border: '1px solid #EDB500',
          borderRadius: '4px',
          padding: '20px 24px',
          marginBottom: '20px',
          display: 'flex',
          alignItems: 'center',
          gap: '30px',
          flexWrap: 'wrap'
        }}
      >
        <div style={{ textAlign: 'center', minWidth: '120px' }}>
          <div style={{ color: '#EDB500', fontSize: '1.8em', fontWeight: 'bold' }}>
            {avgStar || 0} <span style={{ fontSize: '0.6em', fontWeight: 'normal' }}>dari 5</span>
          </div>
          <div style={{ color: '#EDB500', fontSize: '1.3em', marginTop: '4px' }}>
            {'★'.repeat(Math.round(avgStar || 5))}
            {'☆'.repeat(5 - Math.round(avgStar || 5))}
          </div>
        </div>

        <div style={{ flex: 1, display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }}>
          <button
            onClick={() => handleFilterStar(null)}
            style={{
              padding: '6px 20px',
              fontSize: '0.9em',
              borderRadius: '2px',
              cursor: 'pointer',
              backgroundColor: '#fff',
              border: selectedStar === null ? '1px solid #EDB500' : '1px solid #dad8d6ff',
              color: selectedStar === null ? '#EDB500' : '#333',
              fontWeight: selectedStar === null ? 'bold' : 'normal',
              outline: 'none'
            }}
          >
            Semua
          </button>

          {[5, 4, 3, 2, 1].map((star) => (
            <button
              key={star}
              onClick={() => handleFilterStar(star)}
              style={{
                padding: '6px 14px',
                fontSize: '0.9em',
                borderRadius: '2px',
                cursor: 'pointer',
                backgroundColor: '#fff',
                border: selectedStar === star ? '1px solid #EDB500' : '1px solid #dad8d6ff',
                color: selectedStar === star ? '#EDB500' : '#333',
                fontWeight: selectedStar === star ? 'bold' : 'normal',
                outline: 'none'
              }}
            >
              {star} Bintang ({formatCount(starsCount[star])})
            </button>
          ))}
        </div>
      </div>

      {loadingReviews ? (
        <p className="text" style={{ color: '#888' }}>
          Memuat ulasan...
        </p>
      ) : visibleReviews.length > 0 ? (
        <>
          {visibleReviews.map((rev, index) => {
            const dateStr = rev.created_at
              ? new Date(rev.created_at).toLocaleDateString('id-ID', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
              })
              : ''

            const rawName = rev.user?.name || rev.name || rev.user_name || 'Pengguna'
            const formatMaskName = (str) => {
              if (!str) return 'Pe******a'
              const trimmed = String(str).trim()
              if (trimmed.length <= 2) return trimmed.slice(0, 1) + '*'
              if (trimmed.length === 3) return trimmed.slice(0, 2) + '*'
              const firstTwo = trimmed.slice(0, 2)
              const lastOne = trimmed.slice(-1)
              const stars = '*'.repeat(Math.max(trimmed.length - 3, 3))
              return `${firstTwo}${stars}${lastOne}`
            }
            const maskedName = formatMaskName(rawName)

            return (
              <div
                key={rev.id || index}
                style={{
                  borderBottom: '1px solid #eee',
                  padding: '12px 0',
                  marginBottom: '10px'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', flexWrap: 'wrap' }}>
                  <span style={{ fontWeight: 'bold', fontSize: '0.9em', color: '#333' }}>
                    {maskedName}
                  </span>
                  <span style={{ color: '#ffb400', fontSize: '1.1em' }}>
                    {'★'.repeat(rev.star || 5)}{'☆'.repeat(5 - (rev.star || 5))}
                  </span>
                  <span style={{ fontSize: '0.85em', color: '#777', fontWeight: 'bold' }}>
                    ({rev.star || 5}/5)
                  </span>
                  {dateStr && (
                    <span style={{ fontSize: '0.8em', color: '#999', marginLeft: 'auto' }}>
                      {dateStr}
                    </span>
                  )}
                </div>
                <p style={{ margin: 0, fontSize: '0.92em', color: '#444' }}>
                  {rev.review || 'Ulasan tidak disertakan.'}
                </p>
              </div>
            )
          })}

          {/* Pagination << < 1 2 3 ... 5 > >> */}
          {totalPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '6px', marginTop: '20px', marginBottom: '10px', flexWrap: 'wrap' }}>
              <button
                disabled={page <= 1}
                onClick={() => handlePageChange && handlePageChange(1)}
                style={{
                  padding: '6px 10px',
                  fontSize: '0.85em',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  backgroundColor: page <= 1 ? '#f5f5f5' : '#fff',
                  color: page <= 1 ? '#ccc' : '#333',
                  cursor: page <= 1 ? 'not-allowed' : 'pointer',
                  outline: 'none'
                }}
              >
                &laquo;
              </button>
              <button
                disabled={page <= 1}
                onClick={() => handlePageChange && handlePageChange(page - 1)}
                style={{
                  padding: '6px 10px',
                  fontSize: '0.85em',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  backgroundColor: page <= 1 ? '#f5f5f5' : '#fff',
                  color: page <= 1 ? '#ccc' : '#333',
                  cursor: page <= 1 ? 'not-allowed' : 'pointer',
                  outline: 'none'
                }}
              >
                &lsaquo;
              </button>

              {getPageNumbers(page, totalPages).map((p, idx) => {
                if (p === '...') {
                  return (
                    <span key={`dots-${idx}`} style={{ padding: '6px 4px', fontSize: '0.85em', color: '#888' }}>
                      ...
                    </span>
                  )
                }

                const isActive = p === page
                return (
                  <button
                    key={`page-${p}`}
                    onClick={() => handlePageChange && handlePageChange(p)}
                    style={{
                      padding: '6px 12px',
                      fontSize: '0.85em',
                      borderRadius: '4px',
                      border: isActive ? '1px solid #EDB500' : '1px solid #ccc',
                      backgroundColor: isActive ? '#EDB500' : '#fff',
                      color: isActive ? '#fff' : '#333',
                      fontWeight: isActive ? 'bold' : 'normal',
                      cursor: 'pointer',
                      outline: 'none'
                    }}
                  >
                    {p}
                  </button>
                )
              })}

              <button
                disabled={page >= totalPages}
                onClick={() => handlePageChange && handlePageChange(page + 1)}
                style={{
                  padding: '6px 10px',
                  fontSize: '0.85em',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  backgroundColor: page >= totalPages ? '#f5f5f5' : '#fff',
                  color: page >= totalPages ? '#ccc' : '#333',
                  cursor: page >= totalPages ? 'not-allowed' : 'pointer',
                  outline: 'none'
                }}
              >
                &rsaquo;
              </button>
              <button
                disabled={page >= totalPages}
                onClick={() => handlePageChange && handlePageChange(totalPages)}
                style={{
                  padding: '6px 10px',
                  fontSize: '0.85em',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  backgroundColor: page >= totalPages ? '#f5f5f5' : '#fff',
                  color: page >= totalPages ? '#ccc' : '#333',
                  cursor: page >= totalPages ? 'not-allowed' : 'pointer',
                  outline: 'none'
                }}
              >
                &raquo;
              </button>
            </div>
          )}
        </>
      ) : (
        <p className="text" style={{ color: '#888', fontStyle: 'italic' }}>
          Belum ada ulasan untuk produk ini.
        </p>
      )}
    </div>
  )
}

export default ProductReviews
